module.exports = __webpack_public_path__ + "media/images/icon_schedule-regular-e382008a1a6c0eff4dd2eb20824ab082.svg";